import React from "react";

import "./UsageProgress.css";

export default function UsageProgress({ items = [], total }) {
  const used = items.reduce((sum, item) => sum + Number(item.value || 0), 0);
  const capacity = Math.max(Number(total) || 0, used);
  const remaining = Math.max(capacity - used, 0);

  return (
    <div className="UsageProgress">
      <div
        className="UsageProgress__Bar"
        role="img"
        aria-label={`Usage by category, ${used} of ${capacity} credits`}
      >
        {items.map((item, index) => {
          const value = Number(item.value) || 0;

          if (value <= 0 || capacity <= 0) {
            return null;
          }

          const shortTitle = item.shortTitle || item.title;

          return (
            <div
              key={item.key || `${item.title}-${index}`}
              className="UsageProgress__Segment"
              style={{
                width: `${(value / capacity) * 100}%`,
                "--usage-progress-color": item.bgcolor,
                ...(item.segmentBg
                  ? { "--usage-progress-segment-bg": item.segmentBg }
                  : {}),
              }}
              title={`${item.title} · ${value}`}
            >
              <span className="UsageProgress__SegmentLabel">
                {`${shortTitle} · ${value}`}
              </span>
            </div>
          );
        })}
        {remaining > 0 && capacity > 0 && (
          <div
            className="UsageProgress__Remaining"
            style={{ width: `${(remaining / capacity) * 100}%` }}
            title={`Available · ${remaining}`}
            aria-hidden
          />
        )}
      </div>

      {items.length > 0 && (
        <ul className="UsageProgress__Legend">
          {items.map((item, index) => (
            <li
              key={item.key || `${item.title}-legend-${index}`}
              className="UsageProgress__LegendItem"
            >
              <span
                className="UsageProgress__LegendSwatch"
                style={{ backgroundColor: item.bgcolor }}
                aria-hidden
              />
              {item.title}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
